import React, { Component } from 'react';
import { connect } from 'react-redux';
import {ImageSvg} from '../../components/ImageSvg';
import {getAsset} from '../../../../common/resources/assets/assets';
import {strings} from '../../../../common/resources/locales/i18n';


class MaintenancePage extends Component {

  render() {

    return (
      <>
        <main id="uc">
          <section id="under-construction">
            <div className="container-fluid d-flex justify-content-center align-items-center flex-column">
              <hr className="mini"/>
                <ImageSvg className="img-fluid" src={getAsset('icVolkswagenFooter')} height={93} width={150} />
                  <h1 className="text-white my-4">{strings('maintenance.siteUnderMaintenance')}</h1>
                  <h5 className="text-white text-center" style={{maxWidth: '50%'}}>{strings('maintenance.backSoon')}</h5>
                  <hr className="mini"/>
            </div>
          </section>
        </main>
      </>
    );
  }

}
/*
const mapStateToProps = ({ }) => {
  return {

  };
};

const mapStateToPropsActions = {

};
*/

export default connect(null, null)(MaintenancePage);
